<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <div id="my-table-id">
                <v-data-table :headers="headers" :items="salary_component_list" dense class="elevation-1 mytable"
                    :search="search">
                    <template v-slot:top>
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>Salary Component</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <span style="width: 20px;"> </span>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                <!-- <v-btn
              color="success"
              outlined
              rounded
              v-if="salary_component_list.length != 0"
            >
              <download-excel
                class="mr-2 pb-3 pt-2"
                :data="salary_component_list"
                :fields="table_fields"
                worksheet="PayRoll_SalaryComponent"
                name="PayRoll_SalaryComponent.xls"
              >
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn> -->
                                <v-btn rounded color="success" outlined
                                    @click="fnExcelReport('my-table-id', 'SalaryComponent')" :loading="loader"><v-icon
                                        color="success">mdi-export</v-icon>Export</v-btn>
                            </v-col>
                            <v-col sm="6" md="4" cols="12">
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                    hide-details> </v-text-field>
                            </v-col>
                            <span style="width: 20px;"></span>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mb-2 button" v-on="on" small>Add Salary Component</v-btn>
                                </template>
                                <v-card>
                                    <v-form v-model="valid">
                                        <v-card-title class="toolbar">
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="12">
                                                        <v-text-field v-model="editedItem.component_name"
                                                            :disabled="editedIndex != -1" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: Basic, Grade, Income Tax...'
                              : 'noneditable'
                          " label="Salary Component Name" :rules="[(v) => !!v || 'required']">
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.component_display_name"
                                                            label="Display Name" hint="Basic, Grade, Income Tax..."
                                                            :rules="[(v) => !!v || 'required']"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.sequence_of_calculation"
                                                            label="Sequence of Calculation" hint="1, 2, 3..."
                                                            :rules="[(v) => !!v || 'required']"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.component_display_order"
                                                            label="Component Display Order" hint="1, 2, 3..."
                                                            :rules="[(v) => !!v || 'required']"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select dense v-model="editedItem.component_type"
                                                            :items="salary_component_type_list" item-text="display_name"
                                                            item-value="component_type_id"
                                                            label="Select Salary Component Type" persistent-hint :hint="
                            editedIndex == -1
                              ? 'Select Component Type :: Earning, Deduction...'
                              : 'Non-Editable'
                          " :disabled="editedIndex != -1" return-object single-line></v-select>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox v-model="editedItem.is_rule_applicable"
                                                            color="success" label="Is Rule Applicable ?"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox v-model="editedItem.is_scaling_applicable"
                                                            color="success"
                                                            label="Is Scaling Applicable ?"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox v-model="editedItem.is_not_for_calculation"
                                                            color="success"
                                                            label="Is Not for Calculation ?"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox v-model="editedItem.status" color="success"
                                                            label="Active"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox v-model="editedItem.is_master_component"
                                                            color="success" label="Is Master Component"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox v-model="editedItem.add_in_salary_master_reg"
                                                            color="success"
                                                            label="Add to employee current salary master (If rule applicable add rules from map salary rule to component and update current salary master) ??"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                            <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                        </v-card-actions>
                                    </v-form>
                                </v-card>
                            </v-dialog>
                        </v-row>
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-switch v-model="item.status" inset color="success" @change="toggleGroup(item)"></v-switch>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-avatar style="" size="25" class="edit-avatar">
                                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:item.is_rule_applicable="{ item }">
                        <span v-if="item.is_rule_applicable">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.is_master_component="{ item }">
                        <span v-if="item.is_master_component">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.is_scaling_applicable="{ item }">
                        <span v-if="item.is_scaling_applicable">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.is_not_for_calculation="{ item }">
                        <span v-if="item.is_not_for_calculation">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                </v-data-table>
            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

      data: () => ({
          valid: false,
        //   extraBreadcrumbItems: [
        //       { text: "Salary Component", disabled: true, href: "" },

        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          overlay: false,
          errorMsg: {
              id: false,
          },
          snackbar_msg: "",
          color: "",
          snackbar: false,
          search: "",
          dialog: false,
          headers: [
              {
                  text: "Sr No.",
                  align: "left",
                  value: "srno",
              },
              {
                  text: "Component Name",
                  align: "left",
                  value: "component_name",
              },
              {
                  text: "Display Name",
                  align: "left",
                  value: "component_display_name",
              },
              {
                  text: "Display Order",
                  align: "left",
                  value: "component_display_order",
              },
              {
                  text: "Sequence of Calculation",
                  align: "left",
                  value: "sequence_of_calculation",
              },
              {
                  text: "Component Type",
                  align: "left",
                  value: "component_type.display_name",
              },
              {
                  text: "Is Rule Applicable",
                  align: "left",
                  value: "is_rule_applicable",
              },
              {
                  text: "Is Scaling Applicable",
                  align: "left",
                  value: "is_scaling_applicable",
              },
              {
                  text: "Is Not for Calculation",
                  align: "left",
                  value: "is_not_for_calculation",
              },
              {
                  text: "Is Master Component",
                  align: "left",
                  value: "is_master_component",
              },
              {
                  text: "Status",
                  align: "left",
                  sortable: false,
                  value: "status",
              },
              { text: "Actions", value: "action", sortable: false },
          ],
          table_fields: {
              "Sr No.": "srno",
              "Component Name": "component_name",
              "Display Order": "component_display_order",
              "Sequence of Calculation": "sequence_of_calculation",
              "Component Type": "component_type.display_name",
              "Is Rule Applicable": "is_rule_applicable",
              "Is Scaling Applicable": "is_scaling_applicable",
              "Is Not for Calculation": "is_not_for_calculation",
              "Is Master Component": "is_master_component",
              Status: "status",
          },
          salary_component_list: [],
          salary_component_type_list: [],
          editedIndex: -1,
          editedItem: {
              id: 0,
              component_name: "",
              status: true,
              is_rule_applicable: true,
              sequence_of_calculation: "",
              component_display_order: "",
              is_scaling_applicable: true,
              is_not_for_calculation: true,
              add_in_salary_master_reg:true,
              is_master_component:false,
              component_type: "",
          },
          defaultItem: {
              id: 0,
              component_name: "",
              status: true,
              is_rule_applicable: true,
              sequence_of_calculation: "",
              component_display_order: "",
              is_scaling_applicable: true,
              is_not_for_calculation: true,
              add_in_salary_master_reg:true,
              is_master_component:false,
              component_type: "",
          },
      }),

      computed: {
          formTitle() {
              return this.editedIndex === -1 ? "New Salary Component" : "Edit Salary Component";
          },
      },

      watch: {
          dialog(val) {
              val || this.close();
          },
          overlay(val) {
              val = () => {
                  this.overlay = false;
              };
          },
      },

      mounted() {
          this.onLoad();
      },
      methods: {
        fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr.No.</th>
      <th>Component Name</th>
      <th>Display Name</th>
      <th>Display Order</th>
      <th>Sequence of Calculation</th>
      <th>Component Type</th>
      <th>Is Rule Applicable</th>
      <th>Is Scaling Applicable</th>
      <th>Is Not For Calculation</th>
      <th>Is Master Component</th>
      <th>Status</th>
      
    </tr>`;

  this.salary_component_list.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td> 
        <td>${item.component_name || ''}</td> 
        <td>${item.component_display_name || ''}</td> 
        <td>${item.component_display_order || ''}</td> 
        <td>${item.sequence_of_calculation || ''}</td> 
        <td>${item.component_type.display_name || ''}</td> 
        <td>${item.is_rule_applicable ? 'Yes' : 'No'}</td> 
        <td>${item.is_scaling_applicable ? 'Yes' : 'No'}</td> 
        <td>${item.is_not_for_calculation ? 'Yes' : 'No'}</td> 
        <td>${item.is_master_component ? 'Yes' : 'No'}</td> 
        <td>${item.status ? 'Active' : 'Inactive'}</td> 
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
          toggleGroup(item) {
              const formData = {
                  id: item.id,
                  status: item.status,
              };
              axios
                  .post("/Payroll/toggleSalaryComponentStatus", formData)
                  .then((res) => {
                      if (res.data.status.code == "SUCCESS") {
                          this.showSnackbar("#4caf50", "Salary Component Status Changed...");
                      } else {
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                      window.console.log(error);
                  });
          },
          onLoad() {
              this.overlay = true;
              axios
                  .post("/Payroll/salaryComponent")
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.overlay = false;
                          this.salary_component_list = res.data.component_list;
                          this.salary_component_type_list = res.data.component_type_list;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                      window.console.log(error);
                  })
                  .finally(() => {
                      var overlay = false;
                  });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },

          editItem(item) {
              this.editedIndex = this.salary_component_list.indexOf(item);
              this.editedItem = Object.assign({}, item);
              this.dialog = true;
          },

          close() {
              this.dialog = false;
              setTimeout(() => {
                  this.editedItem = Object.assign({}, this.defaultItem);
                  this.editedIndex = -1;
              }, 300);
          },

          save() {
              if (this.editedIndex > -1) {
                  console.log("1");
                  if (this.isValidated()) {
                      console.log("2");
                      axios
                          .post("/Payroll/editSalaryComponent", this.editedItem)
                          .then((res) => {
                              if (res.data.status == "YES") {
                                  Object.assign(this.salary_component_list[this.editedIndex], this.editedItem);
                                  this.onLoad();
                                  this.showSnackbar("#4caf50", "Salary Component Updated Successfully..."); // show snackbar on success
                              } else if (res.data.status.code == "NA") {
                                  this.showSnackbar("#b71c1c", "Salary Component Already Present!!!"); // show snackbar on error
                              }
                          })
                          .catch((error) => {
                              window.console.log(error);
                          });

                      this.close();
                  }
              } else {
                  console.log("save api data");
                  console.log(this.editedItem);
                  axios
                      .post("/Payroll/saveSalaryComponent", this.editedItem)
                      .then((res) => {
                          if (res.data.status.code == "SUCCESS") {
                              // this.salary_component_list.push(this.editedItem);
                              this.onLoad();
                              this.showSnackbar("#4caf50", "Salary Component Added Successfully..."); // show snackbar on success
                          } else if (res.data.status.code == "NA") {
                              this.showSnackbar("#b71c1c", "Salary Component Already Present!!!"); // show snackbar on error
                          }
                      })
                      .catch((error) => {
                          window.console.log(error);
                      });

                  this.close();
              }
          }, // end of save()

          isValidated() {
              if (this.editedItem.component_name) {
                  return true;
              } else {
                  return false;
              }
          }, // .....end of isValidated()
      },
  };
</script>
<style scoped>
  .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
  }
  .v-icon-size {
      font-size: 20px;
  }
  .edit-avatar {
      transition: 0.3s;
      border: 1px solid #b0bec5;
  }
  .edit-avatar:hover {
      background-color: #b0bec5;
  }
  .edit-v-icon {
      padding-left: 6px;
      font-size: 15px;
  }
  .edit-v-icon:hover {
      color: white;
  }
</style>
